export default __webpack_public_path__ + "38324ced3c33288d9f3ed46011b3a000.png";